import React from 'react'
import { Image } from 'react-bootstrap'
import { Link } from 'react-router-dom'

const OverviewHeader = () => {
  return (
    <>
      <div className="commitee-header">
        <h1>Overview</h1>
        {/* <Link to="/incidentForm/add"><button className='add-new-btn'> <Image src='/assets/images/add-new-icon.svg' className='me-2' /> Add New</button></Link> */}
      </div>
    </>
  )
}

export default OverviewHeader
